import { ProfileTypes } from '@/constants/applicationProfile'
import { ApplicationPartyCategoryType, ApplicationPartyType } from '@/types/unlock'

const parties: {
  type: ApplicationPartyType
  name: string
  category: ApplicationPartyCategoryType
  predefined?: boolean
}[] = [
  { type: 'sales', name: 'Unlock Sales', category: 'user', predefined: true },
  { type: 'processing', name: 'Unlock Processing', category: 'user', predefined: true },
  { type: 'underwriter', name: 'Unlock Underwriting', category: 'user' },
  { type: 'closer', name: 'Unlock Closing', category: 'user' },
  { type: 'post_closer', name: 'Unlock Post-Closing', category: 'user' },
  { type: 'asset_manager', name: 'Unlock Asset Management', category: 'user' },
  { type: 'appraiser', name: 'Appraiser', category: 'company', predefined: true },
  { type: 'bor', name: 'Broker of Record', category: 'company' },
  { type: 'creditor', name: 'Creditor', category: 'company' },
  { type: 'hoa', name: 'HOA Contact', category: 'company' },
  { type: 'home_insurance', name: 'Home Insurance', category: 'company' },
  { type: 'mortgage_lender', name: 'Mortgage Lender', category: 'company' },
  { type: 'originator', name: 'Originator', category: 'company' },
  { type: 'inspection', name: 'Property Inspection', category: 'company' },
  { type: 'party', name: 'Referring Party', category: 'company' },
  { type: 'settlement_agent', name: 'Settlement Agent', category: 'company' },
  { type: 'escrow', name: 'Title/Escrow', category: 'company', predefined: true },
  { type: 'trustee', name: 'Trustee', category: 'company' },
  { type: 'other', name: 'Other', category: 'other' },
  { type: 'corporate', name: 'Corporate', category: 'company' },
]

export default parties
